module.exports = __webpack_public_path__ + "media/images/ic_templates-64be1482d349487c1c796e3bbf3e9ab5.svg";